import httpClient from "@/services/HttpService";

export default {

    search: (term) => {
        return httpClient.get(`/nhm/search/${term}`);
    },

}
